"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUUID = exports.randomId = void 0;
/**
 * generate random id like "5b3c3c00d289"
 */
function randomId(length = 16) {
    let str = Math.floor(Date.now() / 1e3).toString(16);
    while (str.length < length)
        str += Math.random().toString(16)
            .slice(2);
    return str.slice(0, length);
}
exports.randomId = randomId;
function getUUID() {
    let d = new Date().getTime();
    const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (d + (Math.random() * 16)) % 16 | 0;
        d = Math.floor(d / 16);
        return (c === 'x' ? r : (r & 0x7) | 0x8).toString(16);
    });
    return uuid;
}
exports.getUUID = getUUID;
//# sourceMappingURL=generate.js.map